module.exports = __webpack_public_path__ + "img/KSC03958.b1ce9764.jpg";